import { Box, Button, Container, Typography, Grid } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "./MsWellDoneScreen.css";
import { useConfig } from "../../contexts/ConfigContext";
import { useTranslation } from "react-i18next";

function MsWellDoneScreen() {
  const { config } = useConfig();
  const { t } = useTranslation();
  return (
    <Grid className="ms-set-password-container ms-well-done-screen">
      <div className="ms-wl-bank-logo" data-testid="svg-icon">
        <img src="/ciam/v1/static/images/ms/Worldline-Mint-Horizontal.svg" alt="Worldline" />
      </div>
      <Grid item xs={7} className="right-gradient" data-testid="right-gradient-circle">
        <img src="/ciam/v1/static/images/ms/right-circle.svg" alt="right-circular-gradient" />
      </Grid>
      <div className="ms-set-password-left">
        <Container className="ms-form-container">
          <Box alignItems="center" textAlign="center">
            <CheckCircleIcon className="ms-success-icon" />
            <Typography
              variant="h5"
              fontWeight="600"
              gutterBottom
              className="ms-set-password-title"
              style={{ marginTop: "32px", marginBottom: "8px" }}
            >
              {t("ms.welldone.header")}
            </Typography>
            <Typography variant="body1" gutterBottom className="ms-set-password-description">
              {t("ms.welldone.body")}
            </Typography>

            <form noValidate>
              <Button
                variant="contained"
                color="primary"
                className="ms-login-button"
                fullWidth
                sx={{ mt: 3 }}
                onClick={() => (window.location.href = config?.reportalLoginUrlMS1)}
              >
                {t("ms.login.button")}
              </Button>
            </form>
          </Box>
        </Container>
      </div>
    </Grid>
  );
}

export default MsWellDoneScreen;
